import { render, staticRenderFns } from "./Webgl.vue?vue&type=template&id=0464ff20&scoped=true&"
import script from "./Webgl.vue?vue&type=script&lang=ts&"
export * from "./Webgl.vue?vue&type=script&lang=ts&"
import style0 from "./Webgl.vue?vue&type=style&index=0&id=0464ff20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0464ff20",
  null
  
)

export default component.exports